import { useEffect, useState } from "react";
import { NavLink, useNavigate, useParams } from "react-router-dom";
import { inject, observer } from "mobx-react";

import { htmlFrom } from "utils/functions";

import LoadedComponent from "./LoadedComponent/index";
import CandidatesList from "../CandidatesList/index";
import ForAgent from "./ForAgent";
import ForCandidate from "./ForCandidate";
import Files from "./Files";

import moment from "moment";

import "./onevacancypage.scss";
import "styles/sharedStyles/subMenuBtns.scss";

import backArrow from "images/backArrow.svg";

const OneVacancyPage = ({ token, positions, cities, getOneVacancy, selectedVacancy, error, isLoading, getSettings, clearCandidatesForVacancy }) => {

  const menuBtns = ["Описание", "Агенту", "Кандидатам", "Файлы и схемы проезда"];
  const [isSelected, setIsSelected] = useState("Описание");

  let { id } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    getOneVacancy(id);
    getSettings();

    return () => clearCandidatesForVacancy();
  }, []);

  useEffect(() => {
    !token && navigate("/allvacancies");
  }, [token]);

  return (
    <div className="vacancy-page">
      <div className="d-flex gap-3 align-items-center">
        <p>
          <img src={backArrow} alt="назад" />
        </p>
        <NavLink to="/allvacancies">
          <p className="vacancy-page-back">Вернуться к списку вакансий</p>
        </NavLink>
      </div>
      <div className="submenu-btns-container">
        <div className="submenu-btns">
          {
            menuBtns.map((text, i) => (
              <p
                key={i}
                className={`submenu-btn ${isSelected === text ? "submenu-btn_selected" : ""}`}
                onClick={(e) => setIsSelected(e.currentTarget.innerText)}
              >
                {text}
              </p>
            ))
          }
        </div>
      </div>
      <LoadedComponent isLoading={isLoading} error={error}>
        <div className="vacancy-page-wrapper">
          {
            selectedVacancy && isSelected === "Описание"
              ? (
                <div className="vacancy-info">
                  <div>
                    <div className="d-flex flex-wrap vacancy-info-header">
                      <p className="vacancy-info__date">{moment(selectedVacancy["date_update"]).format("DD.MM.YYYY")}</p>
                      <h1 className={`vacancy-info__position ${selectedVacancy["fire"] === "1" ? "vacancy-info__position_hot" : ""
                        }`}>{positions[selectedVacancy["position_id"]]["title"].split(/ (\d)/)[0]}</h1>
                      <p className={`vacancy-info__region ${selectedVacancy["fire"] === "1" ? "vacancy-info__region_hot" : ""
                        }`}>
                        {cities[selectedVacancy["city_id"]]["title"].length > 0 ? (
                          <>г. {cities[selectedVacancy["city_id"]]["title"]}</>
                        ) : (
                          "Вся Россия"
                        )}
                      </p>
                      <p className="vacancy-info__salary">{selectedVacancy["wages"].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")} руб.</p>
                    </div>
                    <div className="vacancy-info__description vacancy-info__description_desktop">
                      {selectedVacancy["description"] && htmlFrom(selectedVacancy["description"])}
                    </div>
                    {token ? (
                      <div className="vacancy-list vacancy-list_mobile">
                        <CandidatesList
                          // Вознаграждение скрыто в задаче FRONT-843
                          // hot={selectedVacancy["fire"]}
                          // agentsalary={selectedVacancy["agent_wages"].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                          id={id}
                          positionId={selectedVacancy["position_id"]}
                          vacancyId={selectedVacancy["id"]}
                        />
                      </div>
                    ) : null}
                    <div className="vacancy-info__description vacancy-info__description_mobile">
                      {selectedVacancy["description"] && htmlFrom(selectedVacancy["description"])}
                    </div>
                  </div>
                  {
                    token ? (
                      <div className="vacancy-list vacancy-list_desktop">
                        <CandidatesList
                          // Вознаграждение скрыто в задаче FRONT-843
                          // hot={selectedVacancy["fire"]}
                          // agentsalary={selectedVacancy["agent_wages"].replace(/(\d{1,3}(?=(?:\d\d\d)+(?!\d)))/g, "$1" + " ")}
                          id={id}
                          positionId={selectedVacancy["position_id"]}
                          vacancyId={selectedVacancy["id"]}
                        />
                      </div>
                    ) : null
                  }
                </div>
              )
              : isSelected === "Агенту"
                ? <ForAgent
                  description={selectedVacancy.description_agent}
                />
                : isSelected === "Кандидатам"
                  ? <ForCandidate
                    description={selectedVacancy.description_candidate}
                  />
                  : isSelected === "Файлы и схемы проезда"
                    ? <Files
                      files={selectedVacancy.files}
                    />
                    : null
          }
        </div>
      </LoadedComponent>
    </div>
  );
};

export default inject(({ vacanciesStore, usersStore, candidatesStore }) => {
  const { token } = usersStore;
  const { positions, cities, getOneVacancy, selectedVacancy, error, isLoading } = vacanciesStore;
  const { getSettings, clearCandidatesForVacancy } = candidatesStore;
  return {
    token,
    positions,
    cities,
    getOneVacancy,
    selectedVacancy,
    error,
    isLoading,
    getSettings,
    clearCandidatesForVacancy
  };
})(observer(OneVacancyPage));
